/** 
 * Get query params and store 'em in session storage 
 * * @param id      number
 * * @param tags    []string
 */
 /* global localStorage */
export const storeParams = (id = undefined, tags = undefined) => {
    const newId = id ?? document.body.dataset.id ?? undefined // null | str
    const newTags = tags ? tags.split(' ') : document.body.dataset.contentType ? document.body.dataset.contentType.split(' ') : undefined  // null | []string
    
    const mfy = getStoredParams()
    
    if (newId) mfy.ids.push(parseInt(newId))
    mfy.ids = Array.from(new Set(mfy.ids))
    if (newTags) newTags.forEach(_tag => mfy.tags.push(_tag))
    mfy.tags = Array.from(new Set(mfy.tags))
    
    
    localStorage.setItem('mfy', JSON.stringify(mfy))
}
  
/** 
 * Debug func
 */
export const getStoredParams = () => {
    return JSON.parse(localStorage.getItem('mfy')) ?? {ids: [], tags: []}
}